module.exports = __webpack_public_path__ + "img/icon-box.e2297ff3.svg";